<button class="close modalClose" mat-button (click)="onNoClick()" tabindex="-1">
  X
</button>
<h3 mat-dialog-title>Rename Field</h3>
<p class="fieldName">Field: {{ name }}</p>

<form [formGroup]="renameForm">
  <div mat-dialog-content>
    <div class="formRow">
      <span class="label">Display Name</span>
      <span class="field"
        ><mat-form-field style="width: 100%" appearance="fill">
          <input
            matInput
            name="alias"
            id="alias"
            aria-label=""
            formControlName="alias"
          /> </mat-form-field
      ></span>
    </div>
  </div>
  <div mat-dialog-actions align="end">
    <button mat-button mat-dialog-close class="button_small cancel">
      cancel
    </button>
    <button
      mat-button
      class="button_small"
      id="updateField"
      (click)="updateField()"
      tabindex="-1"
    >
      update
    </button>
  </div>
</form>
